import { render, staticRenderFns } from "./ProviderDetail.vue?vue&type=template&id=ee6a6814&scoped=true"
import script from "./ProviderDetail.vue?vue&type=script&lang=js"
export * from "./ProviderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6a6814",
  null
  
)

export default component.exports